module.exports = __webpack_public_path__ + "img/ig.c03fec90.svg";